import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import {
    handleCompleteLater,
    handleNext,
    onCurrentJobSelectionChange,
    onEndDateChange,
    onStartDateChange,
} from './ProfessionalWorkActions';
import { onPrimaryCurrentChange } from '../primaryCurrentJob';
import ProfessionalWorkLayout from './ProfessionalWorkLayout';
import CurrentJobInformationLayout from '../CurrentJobInformationLayout';
import ProfilePicturePageConfig from '../ProfilePicturePageConfig.json';

const ProfessionalWork = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');

     const location = useLocation();
     const currentMatch = location.pathname.includes('current')

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            I_LL_DO_THIS_LATER: handleCompleteLater,
            ROUTER_NAVIGATE: navigate,
            isCurrent: onCurrentJobSelectionChange,
            isPrimaryCurrent: onPrimaryCurrentChange('jobs'),
            REDIRECT: setRedirectUrl
            //startDate: onStartDateChange,
            //endDate: onEndDateChange,
        },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    // const getSocialProfileLinks = () => {
    //     return (domain as any)?.get('SOCIAL_NETWORK_CODE').map((item: any) => ({ socialNetworkCode: item.code, link: '' }));
    // };

    useEffect(() => {
        // if (data['socialProfileLinks'].length === 0) data['socialProfileLinks'] = getSocialProfileLinks();
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);

        const jobRoleCodeDomain = domain.get('JOB_ROLE_CODE');
        if (jobRoleCodeDomain) {
            const filteredJobRoleCode = jobRoleCodeDomain.filter((role) => role.code !== 'VISITING_FACULTY');
            domain.set('JOB_ROLE_CODE', filteredJobRoleCode);
        }

        // This code for Profile Picture Section from config----------
            let updatedFormConfig: any = { ...formConfig };
            console.log("currentMatch",currentMatch)
            if (currentMatch) {
                const rawProfileSection =
                    ProfilePicturePageConfig.sectionRepository.find(
                        (sec: any) => sec.id === "profile"
                    );
                console.log("rawProfileSection",rawProfileSection)
                if (rawProfileSection && !updatedFormConfig.sections?.includes("profile")) {
                    updatedFormConfig = {
                        ...updatedFormConfig,
                        sections: [...(updatedFormConfig.sections ?? []), "profile"],
                        sectionRepository: [
                            ...(updatedFormConfig.sectionRepository ?? []),
                            rawProfileSection as any
                        ],
                    };
                }
            }
            // end here
        
        const updatedJobsWork = (data?.jobs?.length
                ? data.jobs
                : [{}]
            ).map((job: any) => ({
                ...job,
                isCurrent: currentMatch ?  true : job?.isCurrent ?? 0
            }));

        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig: updatedFormConfig,
                data: {
                    ...data,
                    jobs: updatedJobsWork,
                    currentMatch
                },
                domain,
                routeInfo,
            },
        });
    }, []);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    let message = (currentMatch) ? `Since you mentioned you are currently Working for a Company, please provide the details.` :
    `In your work status, you mentioned that you are currently working for an organization. Please provide the details of your current employment`
    const LayoutComponent = currentMatch ? CurrentJobInformationLayout : ProfessionalWorkLayout;

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <LayoutComponent> {!state.flags.isDataLoading && <PageBuilder data={message} />}</LayoutComponent>
        </SmartContext.Provider>
    );
};

export default ProfessionalWork;
